/**
 * Login
 * 
 */
import React, { Component } from 'react';
import { apiUrl } from '../../data/Data';
import Loading from '../../components/loading/Loading';
import { jsx as _jsx } from "react/jsx-runtime";
class Login extends Component {
  constructor(props) {
    super(props);
    const loginUrl = apiUrl(window.location.hostname, false);
    window.location = `${loginUrl}/login`;
  }
  render() {
    return /*#__PURE__*/_jsx(Loading, {});
  }
}
export default Login;